/**
 * Canonical locale for site texts (must match `SITE_TEXTS_BOOT_LOCALE` and fallback maps).
 */
export const SITE_TEXT_CANONICAL_FR = "fr-FR";

/**
 * Normalizes UI / API locale strings so store keys align with `SITE_TEXT_FALLBACKS_BY_LOCALE`.
 * Production data or browsers may use `fr` while fallbacks and boot use `fr-FR`.
 */
export function normalizeSiteTextLocale(locale: string): string {
	const trimmed = locale.trim();
	if (trimmed.length === 0) {
		return SITE_TEXT_CANONICAL_FR;
	}
	const key = trimmed.replace(/_/g, "-").toLowerCase();
	if (key === "fr" || key === "fr-fr") {
		return SITE_TEXT_CANONICAL_FR;
	}
	return trimmed;
}
